import { createCRUDService } from './createCRUDService';
import { VILLAGES } from './api/endpoints';

// Create base CRUD service
const baseCRUD = createCRUDService(VILLAGES.BASE);

// Export service with districtId and talukaId filter support
export const VillageService = {
  ...baseCRUD,

  // Override getAll to support districtId and talukaId filters
  getAll: async ({
    page = 1,
    limit = 5,
    status = '',
    search = '',
    districtId = '',
    talukaId = '',
  } = {}) => {
    const params = { page, limit };
    if (status) params.status = status;
    if (search) params.search = search;
    if (districtId) params.districtId = districtId;
    if (talukaId) params.talukaId = talukaId;
    return baseCRUD.getAll(params);
  },
};

export default VillageService;
